<template>
  <div class="content-body" id="tender">
      <!-- Modal cancel-user-part -->
     <modal name="cancel-user-part" :adaptive="true">
         <div class="card">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('label.canсel-part')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('cancel-user-part')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body">
                  <div class="form-group mx-2">
                    <label for="reasonForCancellations">{{$t('tender.table.coments')}}*</label>
                        <div class="position-relative">
                            <textarea rows="3" class="form-control" name="reasonForCancellation" v-model="reasonForCancellation" ></textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-2">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button" :disabled="!reasonForCancellation"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="canselUserPart()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                    </div>                    
                </div>                
                </div>
             </div>         
        </div>
         <!--  // and card -->           
    </modal>
        <div class="card">
        <div class="card-header">
            <h3 class="card-title" v-if="tender" ref="card-title"><i class="icon-price-tags"></i> {{tender.number}}</h3>
            <div class="heading-elements">                                                    
                
            </div>
        </div>
        <div class="card-body" v-if="tender">
            <!-- ______________________________________main-tables    -->
                <div class="main-tables mobileTbl table-responsive" >
                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                        <thead>
                            <tr>     
                                <!-- <th style="vertical-align: middle;">{{ $t('tender.table.status') }}</th>                                                            -->
                                <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>
                                <th style="vertical-align: middle;">{{ $t('tender.table.downloadDate') }}</th>                                                                                                         
                                <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCar') }}</th>
                                <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>
                                <th style="vertical-align: middle;">{{ $t('tender.table.deliveryDate') }}</th> 
                                    
                                <th style="vertical-align: middle;">{{$t('tender.table.userRate')}}</th> 
                                <!-- <th style="vertical-align: middle;">{{$t('tender.table.bestUserRate')}}</th>  -->
                                <th style="vertical-align: middle;">{{ $t('tender.table.price') }}</th>
                                                    
                            </tr>
                        </thead>                                                       
                        <tbody>                              
                            <tr class="marginTR" > 
                                <!-- <td :data-title="$t('tender.table.status')">  
                                    <span class="badge" :class="$t('tender.statuses.' + tender.status + '.class')">{{ $t('tender.statuses.' + tender.status + '.title') }}</span> 
                                    
                                </td> -->
                                <td :data-title="$t('tender.table.date')"> {{tender.arrayLoading[0].loadingAdress}}</td>                                            
                                <td  :data-title="$t('tender.table.downloadDate')">{{tender.arrayLoading[0].loadingDate}}</td>
                                <td  :data-title="$t('tender.table.productWeight')">{{tender.arrayLoading[0].weight}}</td>
                                <td  :data-title="$t('tender.table.productWeight')">{{tender.arrayLoading[0].typeOfCar}}</td>
                                <td  :data-title="$t('tender.table.deliveryAdress')"> <span class="badge" :class="$t('tender.deliveryStatus.' + tender.deliveryType + '.class')">{{ $t('tender.deliveryStatus.' + tender.deliveryType + '.title') }}</span><br><span v-for="(adress, k) in tender.arrayDelivery" :key="k"><b v-if="tender.arrayDelivery.length > 1">{{ $t('tender.label.deliveryP') +" "+(k+1) + ":" }}</b>{{adress.deliveryAdress}}</span></td>
                                <td  :data-title="$t('tender.table.deliveryDate')">
                                    <span v-for="(adress, k) in tender.arrayDelivery" :key="k">{{adress.deliveryDate}}</span>
                                    
                                </td>
                                
                                <td  :data-title="$t('tender.table.userRate')"><span v-if="tender.userRate" class="text-center badge prise ">{{tender.userRate}}&nbsp;{{tender.currency}}</span></td>
                                <!-- <td  :data-title="$t('tender.table.bestUserRate')"><span v-if="tender.minRate" class="text-center badge prise ">{{tender.minRate}}&nbsp;{{tender.currency}}</span></td> -->
                                <td  :data-title="$t('tender.table.price')"><span v-if="tender.cost" class="text-center badge prise ">{{tender.cost}}&nbsp;{{tender.currency}}</span></td>
                                
                            </tr>   
                        </tbody>
                    </table>

                </div>
                <!-- ____________________and main tables -->
                <div class="d-flex flex-row-reverse mt-2">
                    <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="confirmParticipation()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                    <button type="button"  class="btn btn-outline-danger btn-min-width btn-glow mr-1 mb-1" @click="$modal.show('cancel-user-part')"><font-awesome-icon icon="ban" class="cursor danger" /> {{$t('label.refuse')}}</button>
                </div>
    
        </div>
        </div>
  </div> 
</template>
<script>

  export default {
    name: "tender",
    components: {   
             
        },
    data(){
      return{
          tender:null,
          reasonForCancellation:""
      }
    },
    methods: {
    authByToken(token){
    let dataRequest = {        
        };
        // dataRequest.guidClient = this.$store.state.guidClient;
        this.makeQuery("/service/loginByToken", {dataRequest : dataRequest, token: this.$store.getters.getUserToken})
        .then(res => {
            if(res != null){ 
                this.$store.commit('setGuidUser', res.data.userGuid)                                                        
                this.$store.commit('setUserName', res.data.name)                                                        
                this.$store.commit('setUserToken', res.data.session)                                                        
                this.$store.commit('setUser', JSON.stringify(res.data.username))                                                        
                this.$store.commit('setEmail', res.data.email)                                                        
                this.$store.commit('setClientName', res.data.clientName)                                                        
                this.$store.commit('setGuidClient', res.data.clientGuid)                                                        
                this.$store.commit('setClientEdpro', res.data.clientEdrpo)                                                        
                this.$store.commit('setCurrentUser', res.data.clientGuid)  
                  if (res.data.vat ) {
                     this.$store.commit('setUserPdv', res.data.vat);
                    localStorage.setItem('pdv', res.data.vat);
                    }

                if (res.data.roleAdmin == true){
                     this.$store.commit('setUserRoleAdmin', true);
                     this.$store.commit('setUserRole', "admin");
                }
                if (res.data.roleClient == true){
                     this.$store.commit('setUserRoleClient', true);
                     this.$store.commit('setUserRole', "client");
                }
                if (res.data.roleClientME == true){
                     this.$store.commit('setUserRoleUser', true);
                     this.$store.commit('setUserRole', "clientME");
                }
                if (res.data.roleLogist == true){
                     this.$store.commit('setUserRoleLogist', true);
                     this.$store.commit('setUserRole', "logist");
                }
                if ( this.isValid(res.data.image) ){
                    localStorage.setItem('profileImg', "data:image/jpg;base64," + res.data.image);
                    this.$store.commit('setProfilePhoto',"data:image/jpg;base64," + res.data.image);
                }                                                     
               
            
                if (this.$store.getters.getUserToken){
                    this.getTender()
                }
                else {
                    this.$router.push('/login')
                }
            }
        });                   
    },
        getTender(){                            
            let dataRequest = {
                guidTender: null,
                guidClient: null
                };
            dataRequest.guidClient = this.$store.getters.getGuidClient;         
            dataRequest.guidTender = this.$store.getters.getGuidTender;          
            this.makeQuery("/portal/getInfoTenderClient", {dataRequest : dataRequest, token: this.$store.getters.getUserToken })
            .then(res => {
                if(res.data.result){ 
                    this.tender = res.data.data[0]                                   
                //    console.log(res.data.data);
                }
            });           
        },
        confirmParticipation(){           
            let dataRequest = {
                guidDoc:this.tender.guidDoc,
                guidClient: null
                };
            dataRequest.guidClient = this.$store.getters.getGuidClient;          
            this.makeQuery("/portal/setApproveTender", {dataRequest : dataRequest, token: this.$store.getters.getUserToken  })
            .then(res => {
                if(res.data.result){ 
                    this.showNotification('custom-success','Успіх',"Участь підтверджено ");  
                     this.$router.push('/transport_tender')                  
                //    console.log(res.data.data);
                }
            });
        },
        canselUserPart(){            
            let dataRequest = {                
                guidDoc:this.tender.guidDoc,
                clientGuid:this.$store.getters.getGuidClient,
                comment:this.reasonForCancellation,
                type: 2           
                };               
                this.makeQuery("/portal/cancelPlayTender", {dataRequest : dataRequest, token: this.$store.getters.getUserToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх'," ");  
                        this.$modal.hide('cancel-user-part'); 
                         this.$router.push('/transport_tender')                                       
                       console.log(res);
                    }
                }); 
        },
    
    },    
    computed:{
        
    },
    created() {
        
    },
    mounted(){
        this.authByToken();
    }
  }
</script>

<style>
#tender{
    font-family: Inter,sans-serif!important;
    font-size: 0.8rem;
}

</style> 


// WEBPACK FOOTER //
// src/pages/Tender.vue